import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'
import { Modal, Button, Row, Col, Carousel } from 'react-bootstrap'
import SimpleFormat from '@16g/react-simple-format'
import BookNowButton from '../../ui/BookNowButton'

const Preview = ({ designTemplate }) => (
  <Carousel>
    <Carousel.Item>
      <img src={designTemplate.attributes.primaryImage.videoVariant} className="img-fluid" />
    </Carousel.Item>
    { designTemplate.attributes.additionalImages.map((image, index) =>
    <Carousel.Item key={index}>
      <img src={image.videoVariant} className="img-fluid" />
    </Carousel.Item>
    )}
  </Carousel>
)


@inject("modalContainer")
@observer
export default class DesignTemplateModal extends React.Component {
  static propTypes = {
    designTemplate: PropTypes.object.isRequired,
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    modalContainer: PropTypes.any.isRequired,
    showBookNowButton: PropTypes.bool.isRequired,
    bookNowButtonText: PropTypes.string.isRequired
  }

  render() {
    const { show, onClose, modalContainer, designTemplate, showBookNowButton, bookNowButtonText } = this.props

    return (
      <Modal
        show={show}
        onHide={onClose}
        size="lg"
        container={modalContainer}
      >
        <Modal.Header closeButton>
          <Modal.Title>{ designTemplate.attributes.name }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          { designTemplate.attributes.description ?
            <Row>
              <Col sm={8}>
                <Preview designTemplate={designTemplate} />
              </Col>
              <Col sm={4}>
                <SimpleFormat text={designTemplate.attributes.description} />
              </Col>
            </Row>
            :
            <Preview designTemplate={designTemplate} />
          }
        </Modal.Body>

        <Modal.Footer>
          <div className="btn-group">
            <BookNowButton showBookNowButton={showBookNowButton} bookNowButtonText={bookNowButtonText} />
            <Button onClick={onClose} >Close</Button>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}
